import { useEffect, useState } from "react";
import paymentIcon1 from "/assets/icons/paymentIcon1.svg";
import paymentIcon2 from "/assets/icons/paymentIcon2.svg";
import paymentIcon3 from "/assets/icons/paymentIcon3.svg";
import paymentIcon4 from "/assets/icons/paymentIcon4.svg";
import paymentIcon5 from "/assets/icons/paymentIcon5.svg";

const PaymentIcons = () => {
  const [isMobile, setIsMobile] = useState(false);
  const base = window?.post_template?.checkout_v4_form;
  const paymentIcons = [paymentIcon1, paymentIcon2, paymentIcon3, paymentIcon4, paymentIcon5];
  const icons = base?.checkout_v4_form_payment_icons?.checkout_v4_form_payment_icons_icon_images?.length
    ? base.checkout_v4_form_payment_icons.checkout_v4_form_payment_icons_icon_images.map((icon) => icon.icon_logo)
    : paymentIcons;

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 460);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const containerStyle = {
    display: "flex",
    gap: isMobile ? "21.78px" : "26px",
    marginTop: "16px",
    marginLeft: "auto",
    marginRight: "auto",
    marginBottom: isMobile ? "16px" : "24px",
    justifyContent: "center",
  };

  return (
    <div style={containerStyle}>
      {icons.map((icon, index) => (
        <img key={index} src={icon} style={{ height: isMobile ? "20px" : "26px" }} alt="Payment Icon" />
      ))}
    </div>
  );
};

export default PaymentIcons;
